import { trustMetrics } from '../../mocks/testimonials';

export default function TrustMetrics() {
  const metrics = [
    { label: 'Active Tradies', value: trustMetrics.totalTradies, icon: 'ri-team-line' },
    { label: 'Total Invoiced', value: trustMetrics.totalInvoiced, icon: 'ri-money-dollar-circle-line' },
    { label: 'Average Rating', value: `${trustMetrics.averageRating}★`, icon: 'ri-star-fill' },
    { label: 'Time Saved/Week', value: trustMetrics.averageTimeSaved, icon: 'ri-time-line' }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
      {metrics.map((metric, index) => (
        <div
          key={index}
          className="bg-white rounded-xl p-6 text-center shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
        >
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
            <i className={`${metric.icon} text-3xl text-teal-600`}></i>
          </div>
          <div className="text-3xl font-bold text-gray-900 mb-1">{metric.value}</div>
          <div className="text-sm text-gray-600">{metric.label}</div>
        </div>
      ))}
    </div>
  );
}